<template>
  <div class="contaier">
    <div class="top-nvb_box">
      <div class="top-nvb">
        <div class="logo-box">
          <router-link to="/"><img alt="" class="img" src="../assets/img/logo.png" /></router-link>
        </div>
      </div>
    </div>
    <div class="mt-[70px] pb-[80px]" v-if="user">
      <div align="center">
        <div class="open_email" style="margin-left: 8px; margin-top: 8px; margin-bottom: 8px; margin-right: 8px;">
          <div>
            <br>
            <span class="genEmailContent">
              <div id="cTMail-Wrap"
                style="word-break: break-all;box-sizing:border-box;text-align:center;min-width:320px; max-width:500px; border:1px solid #f6f6f6; background-color:#faf8f7; margin:auto; padding:20px 0 30px; font-family:'helvetica neue',PingFangSC-Light,arial,'hiragino sans gb','microsoft yahei ui','microsoft yahei',simsun,sans-serif">
                <div class="main-content" style="">
                  <table style="width:100%;font-weight:300;margin-bottom:10px;border-collapse:collapse">
                    <tbody>
                      <tr style="font-weight:300">
                        <td style="width:3%;max-width:30px;"></td>
                        <td style="max-width:500px;">
                          <div id="cTMail-logo" style="width:190px; height:34px;">
                            <a href="javascript:;">
                              <img border="0" src="https://www.kamlung.net/images/icaur/other/icaur190.png"
                                style="width:190px; height:34px;display:block">
                            </a>
                          </div>
                          <p
                            style="height:2px;background-color: #161c2a;border: 0;font-size:0;padding:0;width:100%;margin-top:20px;">
                          </p>

                          <div id="cTMail-inner"
                            style="background-color:#fff; padding:23px 0 20px;box-shadow: 0px 1px 1px 0px rgba(122, 55, 55, 0.2);text-align:left;">
                            <table
                              style="width:100%;font-weight:300;margin-bottom:10px;border-collapse:collapse;text-align:left;">
                              <tbody>
                                <tr style="font-weight:300">
                                  <td style="width:3.2%;max-width:30px;"></td>
                                  <td style="max-width:480px;text-align:left;">
                                    <h1 id="cTMail-title"
                                      style="font-size: 20px; line-height: 36px; margin: 0px 0px 22px;">
                                      恭喜你！你已成功預約 iCAUR V23。
                                    </h1>

                                    <p class="cTMail-content"
                                      style="line-height: 24px; font-size: 15px; font-weight: 600; margin: 6px 0px 0px; overflow-wrap: break-word; word-break: break-all;">
                                      預約詳情：
                                    </p>

                                    <p class="cTMail-content"
                                      style="line-height: 24px; margin: 6px 0px 0px; overflow-wrap: break-word; word-break: break-all;">
                                      <span style="color: rgb(51, 51, 51); font-size: 14px;">
                                        {{ user.lastName }}{{ user.firstName }} ({{ user.title }})
                                      </span>
                                    </p>

                                    <p class="cTMail-content"
                                      style="line-height: 24px; margin: 6px 0px 0px; overflow-wrap: break-word; word-break: break-all;">
                                      <span style="color: rgb(51, 51, 51); font-size: 14px;">
                                        訂車合同編號：{{ user.contract }}
                                      </span>
                                    </p>

                                    <p class="cTMail-content"
                                      style="line-height: 24px; margin: 6px 0px 0px; overflow-wrap: break-word; word-break: break-all;">
                                      <span style="color: rgb(51, 51, 51); font-size: 14px;">
                                        手提電話：{{ user.phone }}
                                      </span>
                                    </p>

                                    <p class="cTMail-content"
                                      style="line-height: 24px; margin: 6px 0px 0px; overflow-wrap: break-word; word-break: break-all;">
                                      <span style="color: rgb(51, 51, 51); font-size: 14px;">
                                        電郵：{{ user.email }}
                                      </span>
                                    </p>

                                    <p class="cTMail-content"
                                      style="line-height: 24px; margin: 6px 0px 0px; overflow-wrap: break-word; word-break: break-all;">
                                      <span style="color: rgb(51, 51, 51); font-size: 14px;">
                                        您的意向車型：{{ user.carModel }}
                                      </span>
                                    </p>

                                    <p class="cTMail-content"
                                      style=" font-size: 24px; margin: 6px 0px 0px; overflow-wrap: break-word; word-break: break-all;">
                                      <span style="color: rgb(51, 51, 51); font-size: 14px; ">
                                        預約日期時間：<strong style="font-weight: 600;">{{
                                          user.date | formatDate }}
                                          ({{ user.timePeriod }})</strong>
                                      </span>
                                    </p>

                                    <p class="cTMail-content"
                                      style=" font-size: 24px; margin: 6px 0px 0px; overflow-wrap: break-word; word-break: break-all;">
                                      <span style="color: rgb(51, 51, 51); font-size: 14px; ">
                                        取車地點：<strong style="font-weight: 600;">九龍灣宏冠道6號鴻力中心B8-9地下</strong>
                                      </span>
                                    </p>

                                    <p class="cTMail-content"
                                      style="font-size: 14px; color: rgb(23, 29, 41); line-height: 24px; margin: 6px 0px 0px; word-wrap: break-word; word-break: break-all;">
                                      <a id="cTMail-btn" href="https://maps.app.goo.gl/A2abQj32LQN2EH7a6"
                                        target="_blank" title="ICAUR 租車中心"
                                        style="font-size: 16px; line-height: 45px; display: block; background-color: #ef801a; color: #000; font-weight: 600; text-align: center; text-decoration: none; margin-top: 20px; border-radius: 3px;">
                                        導航到店
                                      </a>
                                    </p>

                                    <p class="cTMail-content"
                                      style="line-height: 24px; margin: 6px 0px 0px; overflow-wrap: break-word; word-break: break-all;">
                                      <span style="color: rgb(51, 51, 51); font-size: 14px;">
                                        <br>
                                        無法正常顯示？請複製以下連結至瀏覽器打開：
                                        <br>
                                        <a :href="`http://117.50.56.31:7030/eUserInfo?v=${user.strId}`" target="_blank"
                                          title="ICAUR 租車网"
                                          style="color: #ef801a; text-decoration: none; word-break: break-all; overflow-wrap: normal; font-size: 14px;">
                                          這裡是的連結
                                        </a>
                                      </span>
                                    </p>

                                    <dl style="font-size: 14px; color: rgb(51, 51, 51); line-height: 18px;">
                                      <dd
                                        style="margin: 0px 0px 6px; padding: 0px; font-size: 12px; line-height: 22px;">
                                        <p
                                          style="font-size: 14px; line-height: 20px; word-wrap: break-word; word-break: break-all; margin-top: 32px;margin-bottom: 0;">
                                          <a style="color: #333;" href="tel:852 7072 8028"><strong>WhatsApp: +852 7072
                                              8028</strong></a>
                                        </p>
                                        <p id="cTMail-sender"
                                          style="font-size: 14px; line-height: 20px; word-wrap: break-word; word-break: break-all; margin-top: 10px;">

                                          <strong>© iCAUR Hong Kong 2026 All rights reserved</strong>
                                        </p>
                                      </dd>
                                    </dl>
                                  </td>
                                  <td style="width:3.2%;max-width:30px;"></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                        </td>
                        <td style="width:3%;max-width:30px;"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-[200px] text-center text-[30px]" v-if="!user">
      你的序号异常，请确定正常的序号。<br />或重新打开邮件上的链接。</div>
    <footer-page class=" fixed bottom-0 w-full"></footer-page>

    <el-dialog top="35vh" width="190px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="dialogVisible2">
      <div class="dialog-box dialog-box2">
        <i class="el-icon-loading icon-check"></i>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FooterPage from "@/components/FooterPage.vue";
import { icaurRentCarUserInfoApi } from "@/Api/requestApi";
import moment from 'moment'

export default {
  name: "eUserInfo",
  components: {
    FooterPage,
  },
  data() {
    return {
      v: '',
      user: '',
      dialogVisible2: false
    };
  },
  filters: {
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD');
    }
  },
  mounted() {
    if (this.$route.query.v == '' || this.$route.query.v == undefined) {
      this.dialogVisible2 = true;

      setTimeout(() => {
        this.dialogVisible2 = false;
        this.$router.push({ path: "/" });
      }, 2000);
    } else {
      this.dialogVisible2 = true;

      this.v = this.$route.query.v
      // console.log('1111111', this.$route.query.v)
      this.userInfo(this.v)
    }
  },
  //   onUnmounted(() => {
  //   window.removeEventListener('resize', handleResize);
  // })
  methods: {
    async userInfo(v) {
      const {
        data: { code, data },
      } = await icaurRentCarUserInfoApi({ strId: v });
      console.log('code', code, data)
      if (code == 200) this.user = data
      if (code) this.dialogVisible2 = false
    }
  },
};
</script>

<style lang="scss" scoped>
@import "element-ui/lib/theme-chalk/display.css";

#app {
  height: auto
}

.img {
  object-fit: cover;
}

::v-deep .el-dialog {
  border-radius: 10px !important;
  background: none !important;
  background-color: rgba(000, 000, 000, 0.6) !important;
}

.contaier {

  .top-nvb_box {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    border-bottom: #ccc solid 1px;
    z-index: 1000;
    background-color: #fff;


    .top-nvb {
      position: relative;
      max-width: 1200px;
      margin: 0 auto;
      padding: 20px 0;

      .logo-box {
        max-width: 120px;
        margin: 0 auto;
      }

      .lang {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translate(0%, -50%);
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  .dialog-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .icon-check {
      font-size: 60px;
      font-weight: 600;
      color: #fff;
    }

    .title {
      padding-top: 10px;
      font-size: 16px;
      color: #fff;
    }
  }

  .dialog-box2 {
    padding-top: 5px;
    padding-bottom: 30px;
  }

}
</style>
